/** 
*@author: satyamurthy.a
*@Description : 
**/import './style.css';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { InboxOutlined, DownloadOutlined } from '@ant-design/icons';
import localStorage from '../../../utils/localStorage';
import { API_HMI, UPLOAD } from '../../../commons/api';
import { message, Button, Tabs, Checkbox, Row, Col, Card, Collapse, Upload } from 'antd';
import { getHMICalls, _getReportData, getDatasourceData, selectDashboard } from './ApiCalls';

const { TabPane } = Tabs;
const { Panel } = Collapse;

const BulkUploadComponent = ({ translationCache }) => {
  const [datasource, setDatasource] = useState([]);
  const [dashboardData, setDashboardData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [elogData, setElogData] = useState([]);
  const [selectElogData, setSelectElogData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [selectReport, setSelectReport] = useState([]);
  const [selectDashboards, setSelectDashboards] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      await _getHmiList();
    };
    fetchData();
  }, []);

  const onChange = (checkedValues) => {
    const selected = datasource.filter((data) => checkedValues.includes(data.Name));
    setSelectedData(selected);
  };

  const onChangeElog = (checkedValues) => {
    const selected = elogData.filter((data) => checkedValues.includes(data.ShortDescription));
    setSelectElogData(selected);
  };

  const onChangeReport = (checkedValues) => {
    const selected = reportData.filter((data) => checkedValues.includes(data.ReportName));
    setSelectReport(selected);
  };

  const onChangeDashboard = (checkedValues) => {
    const selected = dashboardData.filter((data) => checkedValues.includes(data.Name));
    setSelectDashboards(selected);
  };

  const _getHmiList = async () => {
    try {
      const siteId = localStorage.get('currentSite');
      const payload = { method: 'GET', url: `${API_HMI.GET}?SiteId=${siteId}` };
      const datasource = await getHMICalls(payload);
      const reportData = await _getReportData();
      const dashboardData = await selectDashboard();
      const elogData = await getDatasourceData();

      setDatasource(datasource);
      setReportData(reportData);
      setDashboardData(dashboardData);
      setElogData(elogData);
    } catch (error) {
      console.error('Error fetching HMI list:', error);
      message.error('Failed to fetch data. Please try again later.');
    }
  };

  const beforeUpload = (file) => {
    const isLt2M = file.size / 1024 / 1024 < 10;
    const isJSON = file.type === 'application/json';
    if (!isJSON) {
      message.error('You can only upload JSON files!');
    }
    if (!isLt2M) {
      message.error('JSON file must be smaller than 10MB!');
    }
    return isLt2M && isJSON;
  };

  const handleChange = (info) => {
    const { status } = info.file;
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  return (
    <Tabs style={{ minHeight: window.innerHeight - 170 }} defaultActiveKey="1">
      <TabPane tab={translation('Export')} key="1">
        <div style={{ padding: '30px' }}>
          <Collapse>
            <Panel header={translation('HMI Configuration')} key="1">
              <div style={{ padding: '10px' }}>
                <Checkbox.Group onChange={onChange} style={{ display: 'flex' }}>
                  <Row gutter={16}>
                    {datasource.map((name, index) => (
                      <Col key={index} className="gutter-row" span={6}>
                        <Card
                          style={{
                            textAlign: 'center',
                            marginBottom:"10px"
                          }}
                          bordered={false}>
                          <Checkbox style={{ width: '100%' }} value={name.Name}>
                            {translation(name.Name)}
                          </Checkbox>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
                {selectedData.length >= 1 && (
                  <Button
                    icon={<DownloadOutlined />}
                    type="primary"
                    href={`data:text/json;charset=utf-8,${encodeURIComponent(
                      JSON.stringify(selectedData)
                    )}`}
                    download="hmiConfiguration.json">
                    {`Download `}
                  </Button>
                )}
              </div>
            </Panel>
            <Panel header={translation('Dashboard Configuration')} key="2">
              <div style={{ padding: '10px' }}>
                <Checkbox.Group onChange={onChangeDashboard} style={{ display: 'flex' }}>
                  <Row gutter={16}>
                    {dashboardData.map((name, index) => {
                      return (
                        <Col key={index} className="gutter-row" span={6}>
                          <Card
                            style={{
                              marginBottom: '10px',
                              textAlign: 'center'
                            }}
                            bordered={false}>
                            <Checkbox style={{ width: '100%' }} value={name.Name}>
                              {translation(name.Name)}
                            </Checkbox>
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>
                </Checkbox.Group>
                {selectDashboards.length >= 1 && (
                  <Button
                    icon={<DownloadOutlined />}
                    type="primary"
                    href={`data:text/json;charset=utf-8,${encodeURIComponent(
                      JSON.stringify(selectDashboards)
                    )}`}
                    download="dashboardConfiguration.json">
                    {`Download`}
                  </Button>
                )}
              </div>
            </Panel>
            <Panel header={translation('Elog Configuration')} key="3">
              <div style={{ padding: '10px' }}>
                <Checkbox.Group onChange={onChangeElog} style={{ display: 'flex' }}>
                  <Row gutter={16}>
                    {elogData.map((name, index) => (
                      <Col key={index} className="gutter-row" span={4}>
                        <Card
                          style={{
                            marginBottom: '10px',
                            textAlign: 'center',
                          }}
                          bordered={false}>
                          <Checkbox style={{ width: '100%' }} value={name.ShortDescription}>
                            {translation(name.ShortDescription)}
                          </Checkbox>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
                {selectElogData.length >= 1 && (
                  <Button
                    icon={<DownloadOutlined />}
                    type="primary"
                    href={`data:text/json;charset=utf-8,${encodeURIComponent(
                      JSON.stringify(selectElogData)
                    )}`}
                    download="ElogConfiguration.json">
                    {`Download `}
                  </Button>
                )}
              </div>
            </Panel>
            <Panel header={translation('Report Configuration')} key="4">
              <div style={{ padding: '30px' }}>
                <Checkbox.Group onChange={onChangeReport} style={{ display: 'flex' }}>
                  <Row gutter={16}>
                    {reportData.map((name, index) => (
                      <Col key={index} className="gutter-row" span={6}>
                        <Card
                          style={{
                            margin: '10px',
                            textAlign: 'center',
                          }}
                          bordered={false}>
                          <Checkbox style={{ width: '100%' }} value={name.ReportName}>
                            {translation(name.ReportName)}
                          </Checkbox>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
                {selectReport.length >= 1 && (
                  <Button
                    icon={<DownloadOutlined />}
                    type="primary"
                    href={`data:text/json;charset=utf- 8,${encodeURIComponent(
                      JSON.stringify(selectReport)
                    )}`}
                    download="reportConfiguration.json">
                    {`Download`}
                  </Button>
                )}
              </div>
            </Panel>
          </Collapse>
        </div>
      </TabPane>
      <TabPane tab={translation('Import')} key="2">
        <div style={{ padding: '30px' }}>
          <Row gutter={16}>
            <Col span={6} className="importCard">
              <Card title={translation('Report Configuration')} bordered={false}>
                <Upload.Dragger
                  name="file"
                  action={`${UPLOAD.BULKUPLOAD}?ModuleType=${'Report'}&SiteId=${localStorage.get(
                    'currentSite'
                  )}`}
                  accept="application/json"
                  multiple={false}
                  headers={{ Authorization: `Bearer ${localStorage.get('accessToken')}` }}
                  beforeUpload={beforeUpload}
                  onChange={handleChange}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    {translation('Click or drag file to this area to upload')}
                  </p>
                  <p className="ant-upload-hint">
                    {translation('1. You can only upload .json file')}
                  </p>
                  <p className="ant-upload-hint">
                    {translation('2. File should be less than 10MB')}
                  </p>
                </Upload.Dragger>
              </Card>
            </Col>
            <Col span={6} className="importCard">
              <Card title={translation('Dashboard Configuration')} bordered={false}>
                <Upload.Dragger
                  name="file"
                  action={`${UPLOAD.BULKUPLOAD}?ModuleType=${'Dashboard'}&SiteId=${localStorage.get(
                    'currentSite'
                  )}`}
                  accept="application/json"
                  multiple={false}
                  headers={{ Authorization: `Bearer ${localStorage.get('accessToken')}` }}
                  beforeUpload={beforeUpload}
                  onChange={handleChange}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    {translation('Click or drag file to this area to upload')}
                  </p>
                  <p className="ant-upload-hint">
                    {translation('1. You can only upload .json file')}
                  </p>
                  <p className="ant-upload-hint">
                    {translation('2. File should be less than 10MB')}
                  </p>
                </Upload.Dragger>
              </Card>
            </Col>
            <Col span={6} className="importCard">
              <Card title={translation('HMI Configuration')} bordered={false}>
                <Upload.Dragger
                  name="file"
                  action={`${UPLOAD.BULKUPLOAD}?ModuleType=${'Hmi'}&SiteId=${localStorage.get(
                    'currentSite'
                  )}`}
                  accept="application/json"
                  multiple={false}
                  headers={{ Authorization: `Bearer ${localStorage.get('accessToken')}` }}
                  beforeUpload={beforeUpload}
                  onChange={handleChange}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    {translation('Click or drag file to this area to upload')}
                  </p>
                  <p className="ant-upload-hint">
                    {translation('1. You can only upload .json file')}
                  </p>
                  <p className="ant-upload-hint">
                    {translation('2. File should be less than 10MB')}
                  </p>
                </Upload.Dragger>
              </Card>
            </Col>
            <Col span={6} className="importCard">
              <Card title={translation('ELOG Configuration')} bordered={false}>
                <Upload.Dragger
                  name="file"
                  action={`${UPLOAD.BULKUPLOAD}?ModuleType=${'Elogbook'}&SiteId=${localStorage.get(
                    'currentSite'
                  )}`}
                  accept="application/json"
                  multiple={false}
                  headers={{ Authorization: `Bearer ${localStorage.get('accessToken')}` }}
                  beforeUpload={beforeUpload}
                  onChange={handleChange}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    {translation('Click or drag file to this area to upload')}
                  </p>
                  <p className="ant-upload-hint">
                    {translation('1. You can only upload .json file')}
                  </p>
                  <p className="ant-upload-hint">
                    {translation('2. File should be less than 10MB')}
                  </p>
                </Upload.Dragger>
              </Card>
            </Col>
          </Row>
        </div>
      </TabPane>
    </Tabs>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(BulkUploadComponent);
